import { createIcon } from '@chakra-ui/react/icon'

const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 10 10',
  path: <path fill="currentColor" d="M4.333 4.333v-4h1.333v4h4v1.334h-4v4H4.333v-4h-4V4.333h4Z" />,
})

export default PlusIcon
